import Splitting from "splitting";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
gsap.registerPlugin(ScrollTrigger);

// revealing text in edito
document.addEventListener('DOMContentLoaded', function () {
  class BlockEdito extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      // console.log('/scripts/block-edito.js loaded');

      // props

      // elements
      this.text = this.querySelector('.js-edito__text');
      this.words;

      // events
      this.init();
      window.addEventListener('resize', this.handleResize);
      // - click
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
    }
    handleResize = () => {
      ScrollTrigger?.refresh();
    };
    init() {
      if (!this.text) return;
      // console.log('init') 

      this.words = Splitting({
        target: this.text,
        by: 'words'
      });
      this.addAnimation();
    }
    addAnimation() {
      if (this.words?.[0]?.words?.length < 1) return;
      // console.log('addAnimation')

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: this.text,
          start: "top 65%",
          end: "bottom 65%",
          scrub: true,
          // markers: true,
          toggleActions: 'play none none reverse'
        }
      }).fromTo(this.words?.[0].words, {
        opacity: 0.5
      }, {
        opacity: 1,
        stagger: 0.1,
        ease: 'power3.inOut'
      }, 0.1);
    }
  }
  customElements.define('block-edito', BlockEdito);
});